import filterOptions from '@enums/filter-options';

export default function customFilter(value, search, item) {
  search = search.toString().toLowerCase();
  return (
    String(item.productKeyDisplay).indexOf(search) !== -1 ||
    String(item.productDescription)
      .toLowerCase()
      .indexOf(search) !== -1
  );
}

/**
 * Filter utility functions for handling retail attributes filters
 */

/**
 * Extracts filter value for a specific filter type from retail attributes filter
 * @param {Array} filters - Array of filter objects
 * @param {string} filterType - Filter type to extract (e.g., 'storegroupOption', 'chainOption')
 * @returns {*} - Filter value or null if not found
 */
export const getFilterValue = (filters, filterType) => {
  const filter = filters.find(f => f.attributeFilterType === filterType);
  return filter ? filter.attributeValue : null;
};

/**
 * Checks if retail attributes filter has tool store group or chain filters
 * @param {Array} filters - Array of filter objects
 * @returns {Object} - Object with hasToolStoreGroupFilter and hasChainFilter boolean flags
 */
export const hasToolStoreGroupOrChainFilters = filters => {
  return {
    hasToolStoreGroupFilter: filters.some(
      filter => filter.attributeFilterType === filterOptions.storegroupOption
    ),
    hasChainFilter: filters.some(
      filter => filter.attributeFilterType === filterOptions.chainOption
    ),
  };
};

/**
 * Detects changes in tool store group or chain filter values
 * @param {Array} newFilter - New filter array
 * @param {Array} oldFilter - Previous filter array
 * @returns {Object} - Object with toolStoreGroupChanged and chainChanged boolean flags
 */
export const detectToolStoreGroupOrChainFilterChanges = (newFilter, oldFilter) => {
  // Get current filter values
  const newToolStoreGroupValue = getFilterValue(newFilter, 'storegroupOption');
  const newChainValue = getFilterValue(newFilter, 'chainOption');

  // Get previous filter values
  const oldToolStoreGroupValue = oldFilter ? getFilterValue(oldFilter, 'storegroupOption') : null;
  const oldChainValue = oldFilter ? getFilterValue(oldFilter, 'chainOption') : null;

  // Check if any of the values have changed
  return {
    toolStoreGroupChanged:
      JSON.stringify(newToolStoreGroupValue) !== JSON.stringify(oldToolStoreGroupValue),
    chainChanged: JSON.stringify(newChainValue) !== JSON.stringify(oldChainValue),
  };
};
